<template>
  <div class="noticeDetail" :style="{'paddingTop': statusBar + 'rem'}">
    <Headerd title="中国国际贸易单一窗口" :back="true" left="返回" :white="true" />
    <div class="noticeDetailmain caringModel-wrap">
      <div class="hd">
        <p class="tittle fs18">{{noticeTitle}}</p>
      </div>
      <!-- <van-divider :style="{ border: '1px #F8F8FC solid', padding: '0 24px' }"></van-divider> -->
      <div style="border: 1px #F8F8FC solid;margin: 16px 24px;"></div>
      <div class="rq">
        <p class="zd fs12" style="float:left;">文章来源：{{publisher}}</p>
        <p class="zd fs12" style="float:right">发布时间：{{publishtime}}</p>
      </div>
      <div class="nr">
        <p class="nrp fs14" v-html='noticeContent'></p>
      </div>
    </div>
  </div>
</template>

<script>
import Headerd from "@/components/Headerd";
import Vue from "vue";
import { Divider } from "vant";
Vue.use(Divider);
export default {
  name: "notice",
  /**
   * 初始化数据
   */
  data() {
    return {
      statusBar: 0,
      // noticeTitle:"李克强:推广国际贸易\"单一窗口\" 实现通关一体化",
      // publisher:"电子口岸数据中心",
      // publishtime:"2019/02/15",
      // noticeContent:"3月5日上午9时，第十二届全国人民代表大会第五次会议在人民大会堂举行开幕会，李克强总理作政府工作报告。李克强在报告2017年重点工作任务时说，促进外贸继续回稳向好。落实和完善进出口政策，推动优进优出。扩大出口信用保险覆盖面，对成套设备出口融资应保尽保。设立服务贸易创新发展引导基金。支持市场采购贸易、外贸综合服务企业发展。加快外贸转型升级示范基地建设。促进加工贸易向产业链中高端延伸、向中西部地区梯度转移。推广国际贸易“单一窗口”，实现全国通关一体化。增加先进技术、设备和关键零部件进口，促进贸易平衡发展和国内产业加快升级。<img src='http://t9.baidu.com/it/u=4169540006,4220376401&fm=79&app=86&f=JPEG?w=1000&h=1500' width='100%'  style='margin:10px 0 10px 0'>"

      noticeTitle: "",
      publisher: "",
      publishtime: "",
      noticeContent: "",
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getMobileNoticDetail();
  },
  /**
   * 方法
   */
  methods: {
    /**
     * 获取详情数据
     */
    getMobileNoticDetail() {
      console.log(`${this.$route.query.noticeId}`);
      //     this.noticeTitle="李克强总理签署国务院令，公布《优化营商环境条例》";
      //     this.publisher="电子口岸数据中心";
      //     this.publishtime="2019/12/24";
      //  //   this.noticeContent="3月5日上午9时，第十二届全国人民代表大会第五次会议在人民大会堂举行开幕会，李克强总理作政府工作报告。李克强在报告2017年重点工作任务时说，促进外贸继续回稳向好。落实和完善进出口政策，推动优进优出。扩大出口信用保险覆盖面，对成套设备出口融资应保尽保。设立服务贸易创新发展引导基金。支持市场采购贸易、外贸综合服务企业发展。加快外贸转型升级示范基地建设。促进加工贸易向产业链中高端延伸、向中西部地区梯度转移。推广国际贸易“单一窗口”，实现全国通关一体化。增加先进技术、设备和关键零部件进口，促进贸易平衡发展和国内产业加快升级。<img src='http://t9.baidu.com/it/u=4169540006,4220376401&fm=79&app=86&f=JPEG?w=1000&h=1500' width='100%'  style='margin:10px 0 10px 0'>";
      //    this.noticeContent="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;10月23日李克强总理签署国务院令，公布《优化营商环境条例》《条例》认真总结了近年来我国优化营商环境的经验和做法，将实践证明行之有效、人民群众满意、市场主体支持的改革举措用法规制度固化下来，重点针对我国营商环境的突出短板和市场主体反映强烈的痛点难点堵点问题，对标国际先进水平，从完善体制机制的层面作出相应规定, 自2020年1月1日起施行。（来源：中国政府网）";

      // this.noticeTitle="倪岳峰主持召开促进跨境贸易便利化专项行动部署会";
      // this.publisher="电子口岸数据中心";
      // this.publishtime="2019/12/14";
      // this.noticeContent="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;12月14日，海关总署署长倪岳峰主持召开促进跨境贸易便利化专项行动部署会，研究明年优化口岸营商环境工作，部署在北京、天津、上海三地口岸开展为期3个月的促进跨境贸易便利化专项行动。倪署长要求充分认识促进跨境贸易便利化、持续优化口岸营商环境的重要意义，对标国际先进水平寻找存在短板和提升空间，扎实开展好专项行动，将各项工作任务落到实处。海关总署党委委员、国家口岸办主任张广志，北京、天津、上海市分管副市长，国家发展改革委、财政部、交通运输部、商务部、市场监管总局，北京、天津、上海市口岸办，海关总署有关部门及部分直属海关相关负责同志参加会议。";

      // this.noticeTitle="哥伦比亚和平进程不确定性上升  国别风险预警信息（第74期）";
      // this.publisher="电子口岸数据中心";
      // this.publishtime="2019/8/29";
      // this.noticeContent="<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;“哥武”前高级领导人宣布重组武装。2019年8月29日，“哥武”前高级领导人伊万·马克斯通过网络视频表达了对和平协议执行情况的不满，表示将重组武装力量，开启“武装斗争新阶段”，并与“哥伦比亚民族解放军”展开合作。随后，哥伦比亚大众革命替代力量党[1]主席罗德里格·隆多尼奥发表讲话，表示绝大部分“哥武”前成员仍将遵守和平协议。马克斯曾是“哥武”与哥伦比亚政府和平谈判的首席代表，并在和平协议签署后进入政坛，但随后成为和平进程的“持不同政见者”，其声明给和平进程的继续推进埋下阴影。</p> <img src='http://apptest.singlewindow.cn/appNotice/appnotice3.png' width='100%'  style='margin:25px 0 '> ";

      this.$http
        .post(
          "zsdyckserver/app/notice/getNoticesById?noticeId=" +
            `${this.$route.query.noticeId}`
        )
        .then((res) => {
          this.noticeTitle = res.resultData.noticeTitle;
          this.publisher = res.resultData.publisher;
          this.publishtime = res.resultData.publishtime;
          this.noticeContent = res.resultData.noticeContent;
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
  beforeDestroy() {
    // this.$tool.beforeDestroy(1);
  },
  components: {
    Headerd,
  },
};
</script>

<style scoped lang="scss">
.noticeDetail {
  text-align: center;
  width: 100%;
  min-height: 100%;
  background: #f7f8fa;
  .noticeDetailmain {
    overflow: auto;
    background: #fff;
    .hd {
      margin: 32px 28px 16px 12px;
      .tittle {
        // font-family:"PingFangSC-Medium";
        // font-weight:600;
        // font-size: 20px;
        // line-height: 25px;
        // text-align:left;
        width: 335px;
        // height:45px;
        font-size: 18px;
        font-family: "PingFangSC-Medium";
        font-weight: 700;
        color: #050f28;
        line-height: 27px;
        text-align: left;
      }
    }
    .rq {
      height: 20px;
      margin: 0 32px;
      .zd {
        // font-size:11px;
        //  font-family:"PingFangSC-Regular";
        //  line-height: 11px;
        //  color: #A0A5AA;
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(160, 165, 170, 1);
        line-height: 20px;
      }
    }
    .nr {
      margin: 18px 24px;
      .nrp {
        //         width:327px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(5, 15, 40, 1);
        line-height: 24px;
        margin-bottom: 36px;
        text-align: left;
      }
    }
  }
}
</style>

